import * as React from 'react'

const i18n = (key): JSX.Element => <span dangerouslySetInnerHTML={{ __html: key }} />

const i18nString = (key): string => key

const getCurrentLanguage = () => 'pl'

export { i18n, i18nString, getCurrentLanguage }
